import type { FaireProductEntity } from "../../entity_types/product";

export const p_bpu4kdr4s6: FaireProductEntity = {
  token: "p_bpu4kdr4s6",
  type: "product",
  name: "CHIFFON FITTED DRESS WITH LONG CAPE SLEEVES",
  brandToken: "b_1udwajl633",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a335d04d1e662cd467e0f725d7717ce0e315e7cf185cfc1dfddc4e3a243c4cc6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68b7897f809be329573fd8952573c59086b2188e66df771be7712dfdf0f8583a.jpeg",
    "https://cdn.faire.com/fastly/72f13f500a2a553454eb0b2e4bff409dc0f6e1cc6eb3670f9af42697556047a2.jpeg",
    "https://cdn.faire.com/fastly/0baedb493bb0c1a1ce80ce54265871a1b1df62c088e9eed0cce0cc995dd32cba.jpeg",
    "https://cdn.faire.com/fastly/cb7b6fa6f031cf73dbe2bbb5c70d09e243d52215fe452836097eed50d926bac3.jpeg",
    "https://cdn.faire.com/fastly/0995a38e1f44c403c1b7586c1d8cd11d105d4cc68e8acaf2449d32e453bd1b67.jpeg",
    "https://cdn.faire.com/fastly/fbf0558a9265020f1cccfbf87fd355b5af652b4a61d2b3a560445408ada753bf.jpeg",
  ],
  priceDollars: 82.8,
  description:
    "Embrace timeless elegance with our fitted chiffon dress, featuring thin straps and a structured corset bodice that highlights your figure. The delicate straps flow into floor-length chiffon cape-like sleeves, adding a touch of ethereal charm. With a lace-up corset back for a precise fit, this gown is perfect for weddings, galas, or any special occasion.\n\nKey Features:\nSilhouette: Sheath\nDesign: Straight neckline, long floor-grazing cape sleeves\nFabric & Material: Chiffon\nFit Detail: Structured boned bodice, lace-up corset back\nOccasions: Ideal for wedding guest, modern mother of the bride & formal events",
  tags: [],
  msrpDollars: 165.59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:17.764Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
